import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { OAuthToComponent } from './OAuthMapping';
import Separator from '../step-landing-page/Separator';
import { Step } from '../views/Step';
import { useOAuthSignup } from './useOAuthSignup';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { OAuthVerificationFailureText } from './OAuthVerificationFailureText';
export const OAuthSignupSection = () => {
  const {
    oAuthsEnabledByFlowConfig,
    atLeastOneOAuthEnabled
  } = useOAuthSignup();
  const {
    isAssignedToVariant
  } = useExperiment(ExperimentKeys.ACQ122, TrackWhen.never);
  const separatorMessage = isAssignedToVariant() ? `views.${Step.LandingPage}.acq122-separator` : `views.${Step.LandingPage}.separator`;

  const renderOAuths = () => {
    const oAuths = Object.keys(oAuthsEnabledByFlowConfig).filter(oAuth => oAuthsEnabledByFlowConfig[oAuth]).map(oAuth => {
      return /*#__PURE__*/_jsxs("div", {
        children: [OAuthToComponent[oAuth], /*#__PURE__*/_jsx(OAuthVerificationFailureText, {
          oAuth: oAuth
        })]
      }, oAuth);
    });
    return oAuths;
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-6",
    children: [renderOAuths(), atLeastOneOAuthEnabled && /*#__PURE__*/_jsx(Separator, {
      message: separatorMessage
    })]
  });
};